// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b6dbd486","453":"211954d1"}[chunkId] + ".chunk.js";
};